import React from 'react';

import { i18nRaw } from '@yandex-int/i18n';
import * as keyset from 'i18n/SmartHomeForm';

import { CloudError } from '../../types/cloud';
import Caption from '../Form/Caption';
import Description from '../Form/Description/Description';
import { FormError } from '../Form/FormError';
import Link from '../Link/Link';

const cloudConsoleUrl = 'https://console.cloud.yandex.ru';

const t = i18nRaw(keyset);

export const functionListErrorMessages: Record<CloudError, React.ReactNode> = {
    [CloudError.FAILED_PRECONDITION]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-accept')}
            </Link>
        </>
    ),
    [CloudError.NOT_FOUND]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-register')}
            </Link>
        </>
    ),
    [CloudError.INTERNAL]: (
        <FormError>
            <Link to={`${cloudConsoleUrl}/support`} target="_blank">
                {t('cloud-error')}
            </Link>
        </FormError>
    ),
    [CloudError.PERMISSION_DENIED]: <FormError>{t('cloud-error-reload')}</FormError>,
    [CloudError.INVALID_ARGUMENT]: <FormError>{t('cloud-error-reload')}</FormError>,
    [CloudError.UNAUTHENTICATED]: <FormError>{t('cloud-error-reload')}</FormError>,
    [CloudError.UNKNOWN]: (
        <FormError>
            <Link to={`${cloudConsoleUrl}/support`} target="_blank">
                {t('cloud-error')}
            </Link>
        </FormError>
    ),
};

const validateFunctionDefaultMessage = t('cloud-error-access');

export const validateFunctionErrorMessages: Record<CloudError, React.ReactNode> = {
    [CloudError.PERMISSION_DENIED]: <>{t('cloud-denied')}</>,
    [CloudError.NOT_FOUND]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-unavailable')}
            </Link>{' '}
        </>
    ),
    [CloudError.INTERNAL]: validateFunctionDefaultMessage,
    [CloudError.FAILED_PRECONDITION]: validateFunctionDefaultMessage,
    [CloudError.INVALID_ARGUMENT]: validateFunctionDefaultMessage,
    [CloudError.UNAUTHENTICATED]: validateFunctionDefaultMessage,
    [CloudError.UNKNOWN]: validateFunctionDefaultMessage,
};

export const emptyFunctionsDescription = (
    <Description>
        <Link to={cloudConsoleUrl} target="_blank">
            {t('cloud-no-functions')}
        </Link>
    </Description>
);

export const functionsCaption = <Caption>{t('cloud-tarif')}</Caption>;
